import type { GameRow } from '../ValueDashboard/types';
import type { LarryMatchView } from '@/lib/larry/types';

/** Kalshi legs for a game row, or null when either leg is missing. */
export function larryLegsOf(game: GameRow): { tickerA: string; tickerB: string } | null {
  const a = game.kalshi?.away?.marketTicker;
  const b = game.kalshi?.home?.marketTicker;
  return a && b ? { tickerA: a, tickerB: b } : null;
}

/** The non-removed Larry match riding this game's two legs (either order). */
export function findLarryMatch(matches: readonly LarryMatchView[], game: GameRow): LarryMatchView | null {
  const legs = larryLegsOf(game);
  if (!legs) return null;
  return (
    matches.find(
      (m) =>
        m.status !== 'removed' &&
        ((m.tickerA === legs.tickerA && m.tickerB === legs.tickerB) ||
          (m.tickerA === legs.tickerB && m.tickerB === legs.tickerA)),
    ) ?? null
  );
}
